const raw = process.env.REACT_APP_RELEASE_VERSION;

/** Repo root semver from package.json, injected at client build (craco). */
export const RELEASE_VERSION =
  typeof raw === 'string' && raw.trim().length > 0 ? raw.trim() : 'dev';
